function getGrowtime(time) {
  let timeString, w, d, h, m, s;

  let timeInSec = time ** 3 + time * 30;

  w = Math.floor(timeInSec / 604800);
  d = Math.floor((timeInSec % 604800) / 86400);
  h = Math.floor((timeInSec % 86400) / 3600);
  m = Math.floor((timeInSec % 3600) / 60);
  s = timeInSec % 60;

  timeString = `${w ? `${w}w ` : ''}${d ? `${d}d ` : ''}${h ? `${h}h ` : ''}${
    m ? `${m}m ` : ''
  }${s ? `${s}s` : ''}`;

  return timeString;
}

function alterName(title = '', link = false) {
  let path;

  if (link) title = title.replace(/('\s)|(')/g, '-');

  path = title
    .toLowerCase()
    .replace(/[^0-9\W\D-]|(\sseed)|[:']|(\s-)/g, '')
    .replace(/\s/g, '-');

  return path;
}

function convertPrice(raw) {
  let wl = Math.round((1 - raw) / raw + 1);
  if (raw < 1) return `${wl} World Lock${wl > 1 ? 's' : ''}`;
  else return `${Math.round(raw)} Seeds / World Lock`;
}

async function fetchPrice(url, query, operationName, variables = []) {
  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      query,
      variables,
      operationName,
    }),
  });

  return await result.json();
}

export { getGrowtime, alterName, convertPrice, fetchPrice };
